<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
  width?: number;
  height?: number;
}

withDefaults(defineProps<icon>(), {
  color: 'shuttle-gray',
  width: 24,
  height: 24,
});
</script>
